import BaseService from '@/services/BaseService';

class CompanyService extends BaseService {
    viewCompany = (id) => this.get(`/view-company/${id}`);

    createCompany = (data) => this.post('/create-company', data);

    getCompanyList = (data) => this.post(
        `/get-company-list?page=${data.page}&per_page=${data.per_page}`,
        data || {},
    );

    updateCompany = (data, id) => this.post(`/edit-company/${id}`, data);

    changeCompanyStatus = (data) => this.post('/update-company-status', data);

    deleteCompany = (id) => this.delete(`/delete-company/${id}`);

    downloadCompanyData = (data) => this.post('/download-company-data', data);

    uploadCompanyData = (formData) => {
        return this.api.post(
            '/upload-company-data',
            formData,
            {
                headers: { 'Content-Type': 'multipart/form-data' },
            },
        );
    };
}

export default new CompanyService();
